import RestClient from './rest-client'
import axios from 'axios'

export default class Address extends RestClient {
  static get url () {
    return this.apiUrl + '/addresses'
  }

  static get paramKey () {
    return 'address'
  }

  static async zipCodeAutoFill (address) {
    var url = `${ process.env.VUE_APP_GEOCODE_URL }${ address }&key=${ process.env.VUE_APP_GEOCODE_API_KEY }`

    const { data } = await axios.post(url, '', { headers: {} })

    return data.results[0]
  }

  static async importCsv (formData) {
    const { data } = await this._post(this.url + '/import', formData)
    return data
  }
}
